/**
 * Usage example:
 *   @debounce()
 *   @HostListener('window:resize', ['$event'])
 *   onWindowResize(event) {
 *     this.resize();
 *   }
 *
 * @param delay - number of milliseconds
 */
export function debounce(delay: number = 300): MethodDecorator {

  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
    const original = descriptor.value as Function;

    descriptor.value = function (...args) {
      clearTimeout(this['_timeout_'+propertyKey]);
      this['_timeout_'+propertyKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}

